import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import Fuse from 'fuse.js';
import { combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { SensorModel } from '../../_models/sensor.model';
import { SensorsStore, SensorState } from './sensors.store';

const sensorFuseOptions = {
    keys: ['deviceId', 'attributes.name'],
    threshold: 0.04,
    ignoreLocation: true,
};
const DEBOUNCE_TIME_MS = 200;

@Injectable({ providedIn: 'root' })
export class SensorsQuery extends QueryEntity<SensorState> {
    sensorDetail$ = this.select((state) => state.detail);

    filteredSensors$ = combineLatest([
        this.select((state) => state.ui.searchInput).pipe(
            debounceTime(DEBOUNCE_TIME_MS),
            distinctUntilChanged()
        ),
        this.selectAll().pipe(
            map((sensors) => ({
                sensors,
                fuse: new Fuse(sensors, sensorFuseOptions),
            }))
        ),
    ]).pipe(
        map(([filter, { sensors, fuse }]) => {
            if (!filter) {
                return sensors;
            }

            return fuse.search(filter).map(({ item }) => item);
        })
    );

    currentPage$ = this.select((state) => state.ui.currentPage);

    itemsPerPage$ = this.select((state) => state.ui.itemsPerPage);

    paginatedData$ = combineLatest([
        this.currentPage$,
        this.itemsPerPage$,
        this.filteredSensors$,
    ]).pipe(
        map(([currentPage, itemsPerPage, sensors]) => {
            console.log(currentPage, itemsPerPage, sensors);
            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            const paginatedData = sensors.slice(startIndex, endIndex);

            const totalPages = Math.ceil(sensors.length / itemsPerPage);

            console.log(startIndex, endIndex, paginatedData);
            return { data: paginatedData, totalPages };
        })
    );

    get error(): any {
        return this.getValue().error;
    }

    get sensorDetail(): SensorModel {
        return this.getValue().detail;
    }

    constructor(protected override store: SensorsStore) {
        super(store);
    }
}
